import { Component, OnInit, input } from '@angular/core';
import { DynamicComponent } from '../dynamic';

@Component({
    selector: 'mutara-analysis-chart',
    template: `<p>analysis-chart works!</p>`,
    standalone: false
})
export class AnalysisChartComponent implements OnInit {
  readonly objectData = input<DynamicComponent | undefined>(undefined);
  
  constructor() { }
  
  ngOnInit(): void {
  }

  catchChip(event: import("@angular/cdk/drag-drop").CdkDragDrop<string[], string[]>) {
    throw new Error("Method not implemented.");
  }

 

}
